import { useState, useEffect } from "react";
import Image from "next/image";
import { useCases } from "../landingData";
import style from "./UseCases.module.scss";

function UseCases({ dictionary }) {
	const [isMobile, setIsMobile] = useState(false);
	const title = dictionary["page_editor_block1_header"] || "Make incredible photos with easy-to-use editor";
	const description =
		dictionary["page_editor_block1_text"] ||
		"Edit photos in just a few clicks with BgRem editor. Adjust photo lighting, change color of image by applying various filters, add cute stickers and text, watermark, resize, crop your image and more. Take a look at some of our most popular tools:";

	useEffect(() => {
		const getWindowWidth = () => {
			if (window.innerWidth <= 480) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};

		getWindowWidth();

		window.addEventListener("resize", getWindowWidth);
		return () => {
			window.removeEventListener("resize", getWindowWidth);
		};
	}, []);

	return (
		<section className={style.section}>
			<div className={style.text}>
				<h2 className={style.title}>{title}</h2>
				<p className={style.description}>{description}</p>
			</div>
			<div className={style.container}>
				{useCases.map((item) => (
					<div key={item.id} className={`${style.item} ${item.adaptiveTitle ? style.adaptive : style.desktop}`}>
						<Image className={style.image} src={isMobile && item.adaptiveTitle ? item.adaptiveUrl : item.imageUrl} width={394} height={280} alt={item.title} />
						<p className={style.itemTitle}>{isMobile && item.adaptiveTitle ? dictionary[item.adaptiveTitle] : dictionary[item.title]}</p>
					</div>
				))}
			</div>
		</section>
	);
}

export default UseCases;
